import React from "react";

import Valuation1 from "./Valuation1";
import Valuation2 from "./Valuation2";
import Valuation3 from "./Valuation3";

const Valuation = ({ round, ...props }) =>
  (round <= 2 && <Valuation1 {...props} round={round} />) ||
  (round <= 4 && <Valuation2 {...props} round={round} />) || (
    <Valuation3 {...props} />
  );

export default Valuation;



// WEBPACK FOOTER //
// ./src/components/analysis/Valuation.js